import { TableCell } from '@/components/ui/table';
import { formatPercentage } from '@/utils/format/number';
import type { UnitOverviewRow } from '@/warranty-v3/entities/overview';

type AvgPcsTagCellProps = {
  row: UnitOverviewRow;
};

export function AvgPcsTagCell({ row }: AvgPcsTagCellProps) {
  return (
    <TableCell narrow justify="left">
      {row.avgPcsTag ? formatPercentage(row.avgPcsTag, 0, 5) : '-'}
    </TableCell>
  );
}
